import React from 'react';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardMedia from '@material-ui/core/CardMedia';
import PropTypes from 'prop-types';

const DiscoverCard = ({element}) => {

  return (
    <>
      <Card
        elevation={0}
        square
      >
        <CardActionArea>
          <CardMedia
            alt={element.alt}
            component="img"
            image={element.img}
            object-fit
            title={element.name}
          />
        </CardActionArea>
      </Card>
    </>
  );
}

DiscoverCard.propTypes = {
  element: PropTypes.object,
};

export default DiscoverCard;
